import React from 'react';
import { SectionTitle } from '../../../styles/shared';
import { getVideoEmbedId } from '../../../utils/media';
import {
  GalleryWrapper,
  IFrame,
  StyledContentWrapper,
  VideoWrapper,
} from './ProductMedia.style';

export interface ProductMediaProps {
  prodVideo: string;
  prodName: string;
  translations: any;
}

const ProductMedia: React.FC<{ data: ProductMediaProps }> = ({
  data,
}: {
  data: ProductMediaProps;
}) => {
  const { prodVideo, prodName, translations } = data ?? {};
  const embededId = getVideoEmbedId(prodVideo ?? '');

  return embededId ? (
    <StyledContentWrapper>
      <GalleryWrapper>
        <VideoWrapper>
          <SectionTitle>
            {translations?.pages?.productMedia?.productMediaTitle}
          </SectionTitle>
          <IFrame
            src={`https://www.youtube.com/embed/${embededId ?? ''}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={`${prodName ?? ''} video`}
          />
        </VideoWrapper>
      </GalleryWrapper>
    </StyledContentWrapper>
  ) : (
    <></>
  );
};

export default ProductMedia;
